<template>
    <!-- <v-list class="transparent">
      <v-list-item>
        <v-list-item-subtitle class="text-wrap pb-3"
          >Lorem ipsum dolor, sit amet consectetur adipisicing elit. In
          reiciendis qui obcaecati quasi assumenda ad iste magni? Vitae atque ab
          beatae ratione, obcaecati ad illo officia, quod deserunt dolor
          molestiae.
        </v-list-item-subtitle>
      </v-list-item>
      <v-divider></v-divider>
    </v-list> -->
    <!-- <v-list v-for="item in about" :key="item.title" class="transparent">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold mb-3">{{
            item.title
          }}</v-list-item-title>
          <v-img :src="item.src" class="mx-auto mb-2" max-width="100"></v-img>
          <v-list-item-subtitle
            class="text-wrap mb-2"
            v-for="(element, index) in item.elements"
            :key="index"
          >
            {{ element.subtitle }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list> -->

    <v-container
        class="pa-0"
        :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
    >
        <h1 class="px-4">
            {{ $t("market.football_about.header1") }}
        </h1>
        <div class="cricket">
            <h2 class="pa-4 pb-0">
                {{ $t("market.football_about.header2") }} :
            </h2>
            <v-card-text>
                <div
                    class="mb-2"
                    v-html="
                        $t(
                            domainType === 'SuperWin'
                                ? 'market.football_about.p1_superwin'
                                : 'market.football_about.p1'
                        )
                    "
                ></div>
            </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="match-winner">
            <h2 class="pa-4 pb-0">{{ $t("market.cricket_about.header3") }}:</h2>
            <v-card-text>
                <!-- v-for="item in matchWinner" :key="item.title" -->
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <!-- v-for="item in item.paras" :key="item.para" -->
                            <v-card-text class="pa-0 mb-2">
                                <!-- v-html="item.para" -->
                                {{ $t("market.cricket_about.p3") }}
                            </v-card-text>
                            <v-card-text class="pa-0 mb-2">
                                {{ $t("market.cricket_about.p4") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/soccer-odds.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/soccer-odds.png`"
                            contain
                            class="mx-auto"
                            max-height="200"
                            alt="soccer odds"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>

        <v-divider></v-divider>
        <div class="fancy">
            <h2 class="pa-4 pb-0">{{ $t("market.cricket_about.header4") }}:</h2>
            <v-card-text>
                <!-- v-for="item in fancy" :key="item.title" -->
                <div class="font-weight-bold">
                    {{ $t("market.football_about.p3") }} :
                </div>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <!-- v-for="(item, index) in item.paras" :key="index" -->
                            <v-card-text class="pa-0 mb-2">
                                <!-- v-html="item.para" -->
                                {{ $t("market.football_about.p4") }}
                            </v-card-text>
                            <v-card-text class="pa-0 mb-2"> </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <!-- v-if="item.src" -->
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/soccer-fancy.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/soccer-fancy.png`"
                            contain
                            class="mx-auto mb-2"
                            max-height="100"
                            alt="soccer fancy"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            domainType: process.env.APP_TITLE,
            CDN_IMG_URL: process.env.CDN_IMG_URL
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
    font-weight: bold;
}
</style>
